import React, { ReactElement, FunctionComponent, memo } from 'react'
import RemoteControlledSwitch from '../../../../BaseComponents/Switch/RemoteControlled'
import { NavigationListItemBasicProps, BasicListItem } from '../..'

export type RemoteControlledNavigationListItemToggleProps = NavigationListItemBasicProps & {
    /** value of the switch */
    value: boolean
    /**
     * callback function triggered when switch is pressed
     *
     * @return true | false
     *
     * @TJS-type function
     */
    onPress: (value: boolean) => void
}

const RemoteControlledToggle: FunctionComponent<RemoteControlledNavigationListItemToggleProps> = ({
    value,
    onPress,
    ...rest
}): ReactElement => (
    <BasicListItem {...rest}>
        <RemoteControlledSwitch value={value} onSwitchPress={onPress} />
    </BasicListItem>
)

export default memo(RemoteControlledToggle)
